import comp from "./MediaWrapper";
export default comp;
